import { render, staticRenderFns } from "./ContasPagarPagarForm.vue?vue&type=template&id=2ec7109b&scoped=true&"
import script from "./ContasPagarPagarForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./ContasPagarPagarForm.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec7109b",
  null
  
)

export default component.exports